import { InjectionToken } from '@angular/core';
import { Task } from 'src/app/models/domain';
import { PagedCollection } from 'src/app/state/paged-collection';

// Starts on page 1; see the note on BOM_ITEM_PAGINATOR. The Akita version's startWith
// computed Number(observable) — always NaN, so always 1 — and UrlPagedTable reads the URL
// itself, so deep links keep working.
export const TASK_PAGINATOR = new InjectionToken('TASK_PAGINATOR', {
  factory: () => new PagedCollection<Task>(),
  providedIn: 'root',
});
